import { JSONClient } from "./bootstrap";
import TidalException from "./exception";

export const downloadTicketById = async (ticketId: string) => {
    try {
        const res = await JSONClient.get(`/dashboard/tickets/download/${ticketId}`)
        return res
    } catch (e) {
        throw new TidalException(e.response.data.message, e.response.data.error)
    }
}

export const getMembership = async (discordConnection: string) => {
    try {
        const res = await JSONClient.post(`/dashboard/subscription/session?discordConnection=${discordConnection}`)
        return res;
    } catch (e) {
        throw new TidalException(e.response.data.message, e.response.data.error)
    }
}

export const refreshUserRoles = async (discordConnection: string) => {
    try {
        const res = await JSONClient.post(`/dashboard/subscription/verify?discordConnection=${discordConnection}`)
        return res;
    } catch (e) {
        throw new TidalException(e.response.data.message, e.response.data.error)
    }
}